import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout from './LegalLayout';

const Terms = () => (
  <LegalLayout
    eyebrow="Legal"
    title="Terms of Service"
    lead="The terms for using this website. Fair and straightforward."
  >
    <p className="legal-meta">Last updated: 3 June 2026</p>

    <h2>Who runs this site</h2>
    <p>
      This website is operated by Isuru Gimhan, a freelance designer and developer based in
      Kalutara, Sri Lanka. By using the site, you agree to these terms. If you don't agree, please
      don't use the site.
    </p>

    <h2>Using the site</h2>
    <p>
      You're welcome to browse and get in touch. In return, please don't misuse the site — for
      example by attempting to disrupt it, access it in unauthorised ways, scrape it at scale, or
      use it for anything unlawful.
    </p>

    <h2>My content</h2>
    <p>
      Unless stated otherwise, the design, text, graphics, logos and work shown on this site belong
      to me or are used with permission. You may not copy, reproduce or reuse them without my
      written consent. Trademarks and brands shown in project work remain the property of their
      respective owners.
    </p>

    <h2>Enquiries are not a contract</h2>
    <p>
      Sending a message through the contact form is an enquiry, not a binding agreement. Any project
      I take on is governed by a separate agreement set out with you before work begins.
    </p>

    <h2>External links</h2>
    <p>
      The site may link to other websites (for example my social profiles). I'm not responsible for
      the content or privacy practices of sites I don't control.
    </p>

    <h2>No warranty</h2>
    <p>
      This website is provided "as is". I work hard to keep it accurate and available, but I don't
      guarantee it will always be error-free or uninterrupted, and information here is for general
      guidance only.
    </p>

    <h2>Limitation of liability</h2>
    <p>
      To the extent permitted by law, I am not liable for any loss or damage arising from your use
      of, or inability to use, this website.
    </p>

    <h2>Governing law</h2>
    <p>
      These terms are governed by the laws of Sri Lanka. Any disputes relating to the site will be
      subject to the jurisdiction of the Sri Lankan courts.
    </p>

    <h2>Changes</h2>
    <p>
      I may update these terms from time to time. The "last updated" date above shows when they last
      changed. Continuing to use the site means you accept the current version.
    </p>

    <h2>Contact</h2>
    <p>
      Questions about these terms? Email{' '}
      <a href="mailto:contact@isurugimhan.com">contact@isurugimhan.com</a>, or see the{' '}
      <Link to="/privacy">privacy policy</Link>.<br />
      Isuru Gimhan · Kalutara, Sri Lanka.
    </p>
  </LegalLayout>
);

export default Terms;
